import { Faq, type FaqItem } from "components/website";

const faqItems: FaqItem[] = [
  {
    question: "How does this improve our hiring speed?",
    answer: "Traditional hiring involves weeks of coordination, multiple tools, and fragmented data. with PrecisionMatch, candidates complete one focused assessment, and you receive integrated insight within days. Only validated candidates proceed to interviews.",
  },
  {
    question: "What does Precision actually measure?",
    answer: "Each assessment integrates technical validation with execution intelligence. Candidates demonstrate role-specific skills through realistic problems while revealing judgment, communication quality, work approach, and decision-making under constraints. All insights are derived from demonstrated behavior, not self-reported claims or isolated skill checks.",
  },
  {
    question: "Can it be customized for our specific roles?",
    answer: "Yes. Every assessment is built around your role requirements and performance standards. You define what success looks like, and we design scenarios that test those capabilities. Candidates are evaluated against your standards, not generic benchmarks.",
  },
  {
    question: "What do we receive after candidates complete the assessment?",
    answer: "You receive one unified intelligence report showing execution strengths, technical capability, communication patterns, work style tendencies, development needs, and risk indicators. No guesswork. No manual reconciliation of disconnected data.",
  },
  {
    question: "How is Precision different from other assessment tools?",
    answer: "Most tools evaluate technical skills in isolation or measure personality separately from capability. PrecisionMatch validates technical competence while simultaneously revealing how candidates think, communicate, and execute in realistic work contexts.",
  },
];

const HowItWorksFaqSection = () => {
  return <Faq faqItems={faqItems} />;
};

export { HowItWorksFaqSection };
